import { IconButton, Tooltip } from "@mui/material";
import { PencilIcon } from "src/icons/quote/PencilIcon";

export const ModifyButton = (
    {
      title,
      modifyCustomRow,
      table,
      row,
      currency,
    }: {
      title: string;
      modifyCustomRow: any;
      table: any;
      row: any;
      currency: any;
    }
) => {
  return (
      <Tooltip title={title}>
        <IconButton onClick={() => modifyCustomRow(row, table.entitytype, table.id, currency)}>
          <PencilIcon/>
        </IconButton>
      </Tooltip>
  );
};
